import _ from 'lodash';
import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class ScheduleServerPlugin extends SmartenitPlugin {
  /**
   * Read schedule table size
   */
  public scheduleTableSize(): void {
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'ScheduleTableSize',
      null,
      false,
      `cacheTTL=${this.stateTTL}`
    );
  }

  /**
   * Query for all the entries in the Schedule table, each entry will be sent separately in a different ListScheduleResponse command
   */
  public listSchedules(): void {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'ListSchedules',
      {},
      true,
      null,
      'cached=false'
    );
  }

  /**
   * Query for a specific entry in the Schedule table, the response will be in the command ListScheduleResponse
   * @param index E_ZCL_UINT8 Index of the schedule entry to query
   */
  public listSchedule(index: number): void {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'ListSchedule',
      { Index: index },
      true,
      null,
      'cached=false'
    );
  }

  /**
   * Query for deleting a specific entry in the Schedule table
   * @param index E_ZCL_UINT8 Index of the schedule entry to query
   */
  public deleteSchedule(index: number): void {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'DeleteSchedule',
      { Index: index },
      true,
      null,
      'cached=false'
    );
  }

  /**
   * Set all the data for the schedule entry specified in the index
   * @param index E_ZCL_UINT8 Index of the schedule entry to update
   * @param flags E_ZCL_BMAP8 Flags for the entry
   * @param time E_ZCL_UINT16 Fixed time for the schedule entry
   * @param endpoint E_ZCL_UINT8 Endpoint to look for the specified ClusterID
   * @param clusterID E_ZCL_UINT16
   * @param operation E_ZCL_ENUM8 Specify the action to perform in the given ClusterID
   * @param methodAttributeID E_ZCL_UINT16
   */
  public setSchedule(index: number, flags: any, time: any, endpoint: any, clusterID: any, operation: any, methodAttributeID: any): void {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'SetSchedule',
      {
        ClusterID: clusterID,
        Endpoint: endpoint,
        Flags: flags,
        Index: index,
        MethodAttributeID: methodAttributeID,
        Operation: operation,
        Time: time,
      },
      true,
      null,
      'cached=false'
    );
  }

  /*
    *MethodAttribute*
    0x00 Method execution
    0x01 Attribute write operation
  */

  /*
    *Flags*:
    0x00 Schedule is disabled
    0x01 Schedule is enabled
    0x03 Schedule enabled for Monday
    0x05 Schedule enabled for Tuesday
    0x09 Schedule enabled for Wednesday
    0x11 Schedule enabled for Thursday
    0x21 Schedule enabled for Friday
    0x41 Schedule enabled for Saturday
    0x81 Schedule enabled for Sunday
  */

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const attributeOrMethod = message && message.attributeOrMethod;
    const response = message && message.data && message.data.response;

    if (attributeOrMethod === 'ListScheduleResponse') {
      this.state.scheduleEntry = response.value;
      this._onUpdate.next({ scheduleList: response.value });
    } else if (attributeOrMethod == 'SetScheduleResponse') {
      this.state.statusEntry = response.value;
      this._onUpdate.next({
        response: {
          index: response.value.Index,
          succes: response.value.Success
        }
      });
    } else if (attributeOrMethod == 'ScheduleTableSize') {
      this.state.sizeTable = response.value;
      this._onUpdate.next({
        sizeTable: response.value,
      });
    }

    return this.state;
  }

  public getStatus(
    context?: string,
    force?: boolean,
    asObservable?: boolean,
    payload?: any,
    sendDirect?: boolean
  ) {
    super.getStatus(context, true, asObservable, payload, sendDirect);
  }
}
